import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import HeaderFooter from "../components/headerFooter";
require("dayjs/locale/th");
dayjs.locale("th");

const columns = [
  { id: "sender", label: "ผู้ส่ง", align: "center", width: "240px" },
  { id: "sampleName", label: "ชื่อตัวอย่าง", align: "center", width: "160px" },
  {
    id: "dateTimeStart",
    label: "วัน - เวลา ที่เริ่ม",
    align: "center",
    width: "140px",
  },
  { id: "place", label: "ต้นทาง - ปลายทาง", align: "center", width: "240px" },
  { id: "status", label: "สถานะ", align: "center", width: "140px" },
];

const DeliverySampleShuttleCar = (props) => {
  const [listBookingNotSuccess, setListBookingNotSuccess] = useState([]);
  const [listBookingIsSuccess, setListBookingIsSuccess] = useState([]);

  useEffect(() => {
    const formatDate = (date) => dayjs(date).format("D MMM YYYY");

    let listBooking = props.booking;
    if (listBooking != null && listBooking.length !== 0) {
      const listA = [];
      const listB = [];

      listBooking.forEach((booking) => {
        const formattedBooking = {
          bookingId: booking.idDeliverySampleShuttle,
          nameLabel: "ผู้ส่ง ",
          name: booking.nameSender,
          phone: booking.phoneSender,
          sampleName: booking.nameSample,
          startDateLabel: "วันที่เริ่ม ",
          startDate: formatDate(booking.date),
          startTime: booking.startTime + " น.",
          fromPlace: `Site ${booking.fromPlaceNoSite}: ${booking.fromPlaceName}`,
          toPlace: `Site ${booking.toPlaceNoSite}: ${booking.toPlaceName}`,
          status: booking.deliveryStatus,
        };

        if (booking.deliveryStatus === "ได้รับสินค้าเรียบร้อย") {
          listA.push(formattedBooking);
        } else {
          listB.push(formattedBooking);
        }
      });

      setListBookingIsSuccess(listA);
      setListBookingNotSuccess(listB);
    } else {
      setListBookingIsSuccess([]);
      setListBookingNotSuccess([]);
    }
  }, [props.booking, props.deliverySampleStatus]);

  return (
    listBookingIsSuccess &&
    listBookingNotSuccess && (
      <HeaderFooter
        columns={columns}
        listBookingIsSuccess={listBookingIsSuccess}
        listBookingNotSuccess={listBookingNotSuccess}
        showHistory={props.showHistory}
        typeOfBooking={props.typeOfBooking}
        onClickCardHandler={props.onClickCardHandler}
      />
    )
  );
};

export default DeliverySampleShuttleCar;
